// Path: ./src/app/components/Button/index.tsx
import { CircularProgress } from "@mui/material";
import * as React from "react";
import { Title, Button } from "./styled";

interface Props {
  title?: string;
  isLoading?: boolean;
  /**
   * Callback function to handle the click event.
   * This function is invoked when the associated element is clicked.
   */
  onClick?: () => Promise<void>;
  children?: React.ReactNode;
  buttonStyleCss?: string;
  titleStyleCss?: string;
  testId?: string;
  style?: React.CSSProperties;
}
export function ButtonComponent({
  title,
  isLoading,
  onClick,
  buttonStyleCss,
  titleStyleCss,
  testId,
  children,
  style,
}: Props) {
  return (
    <Button
      onClick={onClick}
      buttonStyleCss={buttonStyleCss}
      data-testid={testId}
      style={style}
    >
      {isLoading && <CircularProgress color="inherit" size={19} />}

      {title && (
        <Title isLoading={isLoading} titleStyleCss={titleStyleCss}>
          {title}
        </Title>
      )}
      {children}
    </Button>
  );
}
